'use strict';

const wishlistGate = require('../wishlist/wishlistGate');

let $body;

/**
 * Updating Wishlist Indicator for respective products
 *
 * @param {Array} rawProductIDs - Wishlist Product IDs Array
 */
const updateWishlistIndicator = (rawProductIDs) => {
    const productIDs = rawProductIDs;
    const selectorArray = productIDs.map(function (productID) {
        return '.wishlistTile[data-pid=' + productID + '] span.b-tile-fav_button';
    });
    const selectorString = selectorArray.join(', ');
    $(selectorString).addClass('product-added b-tile-fav_selectButton selected');
    $(selectorString).removeClass('b-tile-fav_button');
};

/**
 * Retrieves/Update the user's wishlist by making a GET request to the wishlist AJAX URL.
 * @function updateWishList
 * @param {string} [response] - A string of product IDs separated by '|'. If not provided,
 *     the function makes a GET request to retrieve the wishlist.
*/
const updateWishList = (response) => {
    const getWishListURL = $('#bodyPage').data('wishlist');

    if (response && 'data' in response && response.data) {
        const productIDs = response.data.split('|');
        if (productIDs.length > 0) {
            updateWishlistIndicator(productIDs);
        }
    } else if (getWishListURL) {
        $.ajax({
            url: getWishListURL,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if (data && 'wishlistProductIDsArray' in data && data.wishlistProductIDsArray.length > 0) {
                    updateWishlistIndicator(data.wishlistProductIDsArray);
                }
            }
        });
    }
};

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} icon - icon that was clicked to add a product to the wishlist
 */
function displayMessageAndChangeIcon(data, icon) {
    if (icon.hasClass('product-added')) {
        icon.removeClass('b-tile-fav_button').addClass('b-tile-fav_selectButton');
        icon.addClass('selected');
    } else {
        icon.removeClass('b-tile-fav_selectButton selected').addClass('b-tile-fav_button');
    }
}

/**
 * @description init all components manager events
 */
function initEvents() {
    $body.on('wishlistSuggestion:update', (response) => {
        updateWishList(response);
    });
}

module.exports = {
    init: function () {
        $body = $('body');

        initEvents();
        if ($('.l-plp').length === 0) {
            $body.trigger('wishlistSuggestion:update');
        }
    },

    /**
     * Announces the outcome of a save that authentication interrupted.
     *
     * Hosted here because this module is included on every page by each
     * region's `main.js`, and the customer can return to any of the five
     * surfaces the gate covers. It is a no-op on storefronts where the gate
     * publishes no configuration.
     *
     * Ordering matters: `main.js` initialises the component manager before this
     * module, so a cart line item's component instance already exists when the
     * Save for Later continuation needs it.
     */
    wishlistGateContinuation: function () {
        wishlistGate.handleContinuation();
    },
    addToWishlist: function () {
        $body.on('click', '.wishlistTile', function (e) {
            e.preventDefault();
            var $tile = $(this);
            var icon = $(this).find('.js-whislist-icon');
            var url = $(this).attr('href');
            var pid = $(this).closest('.product').data('pid');
            var variantColor = $(this).closest('.product').data('variantcolor') || '';
            var style = $(this).attr('data-analytics-style');
            var sku = $(this).attr('data-analytics-sku');
            var color = $(this).attr('data-analytics-color');
            var optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
            var optionVal = $(this).closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
            optionId = optionId || null;
            optionVal = optionVal || null;
            if (!url || !pid) {
                return;
            }

            var alreadySaved = $(this).find('.js-whislist-icon').hasClass('product-added');

            // Guest login gate. The surface is derived from where the tile sits
            // rather than from the URL, because PLP, Search and Shop This
            // Outfit all render the same tile through the same route.
            if (!alreadySaved && wishlistGate.intercept($(this), {
                actionType: 'wishlist',
                pid: pid,
                optionId: optionId,
                optionVal: optionVal,
                variantColor: variantColor
            })) {
                return;
            }

            if (alreadySaved) {
                url = $(this).attr('remove-href');
                $(this).find('.js-whislist-icon').removeClass('product-added');
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    data: {
                        pid: pid,
                        optionId: optionId,
                        optionVal: optionVal
                    },
                    success: function (data) {
                        displayMessageAndChangeIcon(data, icon);
                        $('body').trigger('wishlist:updateCount', {
                            count: data.wishlistTotal
                        });
                        $body.trigger('wishlist:removeItemSuccess', {
                            style: style,
                            sku: sku,
                            color: color
                        });
                    },
                    error: function (err) {
                        displayMessageAndChangeIcon(err, icon);
                    }
                });
            } else {
                $(this).find('.js-whislist-icon').addClass('product-added');
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: {
                        pid: pid,
                        optionId: optionId,
                        optionVal: optionVal,
                        variantColor: variantColor,
                        surface: wishlistGate.detectSurface($(this))
                    },
                    success: function (data) {
                        // The gate refused the save. Undo the optimistic fill
                        // before prompting, so the tile does not claim a save
                        // that the customer still has to authenticate for, and
                        // skip the analytics events below because nothing was
                        // added.
                        if (wishlistGate.handleAuthenticationRequired(data, $tile, {
                            actionType: 'wishlist',
                            pid: pid,
                            optionId: optionId,
                            optionVal: optionVal,
                            variantColor: variantColor
                        })) {
                            icon.removeClass('product-added');
                            displayMessageAndChangeIcon(data, icon);
                            return;
                        }

                        displayMessageAndChangeIcon(data, icon);
                        wishlistGate.showConfirmation(data);
                        $('body').trigger('wishlist:updateCount', {
                            count: data.wishlistTotal
                        });
                        $body.trigger('wishlist:addItemSuccess', {
                            style: style,
                            sku: sku,
                            color: color
                        });
                    },
                    error: function (err) {
                        displayMessageAndChangeIcon(err, icon);
                    }
                });
            }
        });
    },

    wishlistAddtoCart: function () {
        $('body').on('click', '.js-wishlist-tile-quickAdd_button', function (e) {
            const $btn = $(this);
            const addToCartUrl = $btn.data('url');
            const earlyAccessProduct = $btn.data('is-ea-product');
            e.preventDefault();

            const qty = $btn.data('qty');

            $btn.trigger('product:beforeAddToCart', $btn);

            const form = {
                options: [],
                pid: $btn.data('pid'),
                quantity: qty,
                mpid: $btn.data('mpid') || $btn.data('pid')
            };

            if (earlyAccessProduct) {
                window.location.href = $btn.data('redirect');
                return;
            }
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success: (data) => {
                    if (data.error) {
                        var availabilityMessages = '';
                        try {
                            availabilityMessages = JSON.parse(data.message);
                        } catch (error) {
                            availabilityMessages = '';
                        }
                        // if (availabilityMessages.outOfStockMsg && availabilityMessages.isNotAvailable) {
                        if (availabilityMessages) {
                            $btn.siblings('.b-notify-cta').eq(0).removeClass('hide').trigger('click');
                        }
                        return;
                    }
                    $('.minicart').trigger('count:update', data);
                    $('body').trigger('product:updateAddToCartModal', data);

                    // show add to cart toast
                    if (data.newBonusDiscountLineItem && Object.keys(data.newBonusDiscountLineItem).length !== 0) {
                        $('[data-cmp="detailBonusProductModal"]').trigger('product:showBonusProducts', data.newBonusDiscountLineItem);
                    }
                    if ($('.b-cart-content.cart').length > 0) {
                        if (data.renderedTemplate) {
                            $('body').trigger('cart:updateCartTotals', [data.cart, this]);
                            if ($('.cart').find('.b-cartlineitem').length === 0) {
                                window.location.reload();
                            } else {
                                // update cart product cards markup
                                $('.js-cart-items').replaceWith(data.renderedTemplate);

                                $('body').trigger('cart:update');
                            }
                        }
                        $('.b-cart_klarna-placement').toggleClass('hide', (data.cart.hasGiftCards || data.cart.hasPreOrder));
                    }

                    var srContainer = $('.b-cart-content_right .b-cart_shoprunner').closest('div');
                    if (data.cart && data.cart.srEligible && srContainer.hasClass('hide')) {
                        srContainer.removeClass('hide');
                    }
                    var analyticsData = {
                        analytics: {
                            isWishlist: true,
                            quantityAdded: qty
                        }
                    };
                    $('body').trigger('product:afterAddToCart', $.extend(data, analyticsData));
                },
                beforeSend: function () {
                    $btn.parent().addClass('active');
                    $btn.children('i').removeClass('icon-qatc').addClass('icon-qatcg');
                },
                complete: function (data) {
                    $btn.parent().removeClass('active');
                    $btn.children('i').removeClass('icon-qatcg').addClass('icon-qatcr');
                    var lineItems = data.responseJSON.lineItems;
                    var lineItem = lineItems.find(item => item.id === $btn.data('pid').toString());
                    setTimeout(function () {
                        if (lineItem.quantity === lineItem.quantityOptions.maxOrderQuantity) {
                            $btn.addClass('d-none');
                        }
                        $btn.children('i').removeClass('icon-qatcr').addClass('icon-qatc');
                    }, 500);
                },
                error: function () {
                    $('.js-add-to-cart').text($('.js-add-to-cart').data('has-error'));
                }
            });
        });
    },

    updateHeaderWishlistCount: function () {
        $('body').on('wishlist:updateCount', function (event, data) {
            var count = data.count;
            if (count !== 0) {
                if (count > 99) {
                    count = '99+';
                }
                if (!$('.b-header-wishlist').find('.wishlist-quantity').length) {
                    $('.b-header-wishlist').find('.b-wishlist-link, .b-wishlist-icon').append(
                        '<span class="wishlist-quantity"></span>'
                    );
                }
                $('.wishlist-quantity').html(count);

                if (data.count > 99) {
                    $('.wishlist-quantity').addClass('wishlist-quantity-large');
                } else {
                    $('.wishlist-quantity').removeClass('wishlist-quantity-large');
                }
            } else if ($('.b-header-wishlist').find('.wishlist-quantity').length) {
                $('.b-header-wishlist').find('.wishlist-quantity').remove();
            }
        });
    }
};
